import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=292a6948&scoped=true"
import script from "./product_detail.vue?vue&type=script&lang=ts"
export * from "./product_detail.vue?vue&type=script&lang=ts"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=292a6948&prod&lang=less"
import style1 from "./product_detail.vue?vue&type=style&index=1&id=292a6948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292a6948",
  null
  
)

export default component.exports